import { render, staticRenderFns } from "./AffiliationPage.vue?vue&type=template&id=270891d7&scoped=true"
import script from "./AffiliationPage.vue?vue&type=script&lang=js"
export * from "./AffiliationPage.vue?vue&type=script&lang=js"
import style0 from "./AffiliationPage.vue?vue&type=style&index=0&id=270891d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270891d7",
  null
  
)

export default component.exports